import {useMutation} from '@tanstack/react-query';
import axios from 'axios';
import {toast} from '@ui/toast/toast';
import {apiClient} from '../../http/query-client';

export interface ForgotPhoneNumberSendOtpPayload {
  email: string;
}

export function useForgotPhoneNumberSendOtp() {
  return useMutation({
    mutationFn: (payload: ForgotPhoneNumberSendOtpPayload) => sendOtp(payload),
    onError: err => {
      const msg = axios.isAxiosError(err) && err.response?.data?.error;
      toast.danger(msg || 'There was an issue. Please try again.');
    },
  });
}

function sendOtp(payload: ForgotPhoneNumberSendOtpPayload) {
  return apiClient
    .post('forgot-phone-number/send-otp', payload)
    .then(response => response.data);
}
